import { createContext, useContext } from "react"

const ArticulosContextProvider = createContext({})

const ArticulosProvider = ({ children, value }: $TSMigrationFixMe) => {
  return (
    <ArticulosContextProvider.Provider value={value}>
      {children}
    </ArticulosContextProvider.Provider>
  )
}

export const useArticulosContext = () => useContext(ArticulosContextProvider)

export default ArticulosProvider
